import { render, staticRenderFns } from "./DeNumberRange.vue?vue&type=template&id=167453bf&scoped=true&"
import script from "./DeNumberRange.vue?vue&type=script&lang=js&"
export * from "./DeNumberRange.vue?vue&type=script&lang=js&"
import style0 from "./DeNumberRange.vue?vue&type=style&index=0&id=167453bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167453bf",
  null
  
)

export default component.exports